import {Base} from "./Base";
import {Product} from "./Product";

export enum WarehouseStatus {
    Locked = 'LOCKED',
    Open = 'OPEN',
}

export interface Warehouse extends Base {
    id: string; // PK

    code: string
    name: string
    longitude?: string
    latitude?: string // Ili opcije ispod
    address?: string
    city?: any
    type?: string
    amount?: number
    weighbridgeModel?: string
    weighbridgePort?: string
    automated?: boolean // default: false
    calculateCalo?: boolean
    status?: WarehouseStatus
    virtual?: boolean
    finishingCenter?: boolean //da li je magacin doradni centar
}

export interface WarehouseOverview extends Base {
    id: string
    warehouse: Warehouse
    product: Product
    input?: number
    inputSrps?: number
    output?: number
    outputSrps?: number
    state?: number
    stateSrps?: number
    reservation?: number
    reservationSrps?: number
    stateWithReservation?: number
    stateWithReservationSrps?: number
    measureUnit?: string
}

export interface WarehouseLoading extends Base {
    id: string
    warehouse: Warehouse
    capacityOccupancy?: number
    capacityExpect?: number
    quantityArrived?: number
    quantityFinished?: number
}
